import { Record, List } from "immutable";

const CampaignRecord = new Record({
  id: undefined,
  name: "",
  geo: [],
  device: [],
  cpc: 0, // cost per click default
  cpc_lock: false,
  scheduler_hour: new List(),
  scheduler_day: new List(),
  translation_start: undefined,
  translation_stop: undefined,

  moneyout_limit: 0,
  workday_moneyout_limit: 0,
  holiday_moneyout_limit: 0,

  workday_limit: 0,
  holiday_limit: 0,
  tag_scheme: "",

  filter_items: "",

  teaser_autostart: true
});

export default class AdwCampaign extends CampaignRecord {}
